.floatingButton {
    position: fixed;
    bottom: 20px;
    right: 20px;
    z-index: 1000;
    cursor: pointer;

    border: none;
    padding: 0;
    margin: 0;
    outline: none;
    box-shadow: none;

    font-size: 40px;
    padding-left: 5px;
    padding-right: 5px;
    background: white;
    border-radius: 4px;
    box-shadow: 0 2px 4px 0 #000000a6;
    min-height: 60px;
    min-width: 60px;

    display: flex;
    justify-content: center;
    align-items: center;

    transition: opacity ease 0.3s;

    &:hover {
        background: #f5f5f5;
    }
}

.modal {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1000;
    background: white;
    border-radius: 4px;
    box-shadow: 0 2px 4px 0 #000000a6;
    padding: 20px;
    max-width: 500px;
    max-height: 80vh;

    display: flex;
    flex-direction: column;
    gap: 8px;

    input, label {
        margin-bottom: 0;
        margin-top: 0;
    }
}